import { Box } from "@mui/material";
import SearchInput from "../../searchInput/SearchInput";
import { GroupedTableSearchProps } from "./useGroupedTableSearch";

type Props = {
  search: GroupedTableSearchProps;
  isSearchGroup: boolean;
  open: boolean;
};

const GroupedTableSearchInput = ({ search, isSearchGroup, open }: Props) => {
  return (
    <>
      {isSearchGroup && open && (
        <Box
          onClick={(e) => e.stopPropagation()}
          display="flex"
          alignItems="end"
          gap="18px"
          height={open && isSearchGroup ? "50px" : "unset"}
        >
          <Box position="absolute" top="8px" left="8px" width="534px">
            <SearchInput
              fullWidth
              value={search.searchValue}
              placeholder={search?.placeholder || ""}
              onInputChange={(newValue: string, reason: string) =>
                search.onInputChange(newValue, reason)
              }
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default GroupedTableSearchInput;
